<template>
	<BaseInput
		v-bind="$attrs"
		:model-value="modelValue"
		:label="label"
		:placeholder="placeholder"
		:autocomplete="autocomplete"
		:status="status"
		:error="error"
		:type="isVisible ? 'text' : 'password'"
		@update:model-value="$emit('update:modelValue', $event)"
		@blur="$emit('blur', $event)"
		@focus="$emit('focus', $event)"
	>
		<template #after>
			<Button
				v-if="showVisibilityToggle"
				button-type="button"
				variant="ghost"
				size="small"
				:icon="isVisible ? Icons.HIDDEN : Icons.VISIBLE"
				class="ar-input__toggle"
				@click="toggle"
				@mousedown.prevent
				:aria-pressed="isVisible"
				:aria-label="$t('common.aria.togglePasswordVisibility')"
			/>
		</template>
	</BaseInput>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import BaseInput from './BaseInput.vue';
import { Button } from '../Button';
import { Icons } from '../Icon';

const props = defineProps({
	modelValue: {
		type: [String, Number],
		default: '',
	},
	label: {
		type: String,
		default: '',
	},
	placeholder: {
		type: String,
		default: '',
	},
	autocomplete: {
		type: String,
		default: 'current-password',
	},
	status: {
		type: String,
		default: '',
	},
	error: {
		type: String,
		default: '',
	},
	showVisibilityToggle: {
		type: Boolean,
		default: true,
	},
});

const isVisible = ref(false);

const toggle = () => {
	isVisible.value = !isVisible.value;
};
</script>

<style lang="scss">
.ar-input__toggle {
	--button-border-width: 0;
}
</style>
